import { useMemo, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetEmployeePost } from "@type/api/user";
import { useAuthStore } from "@type/store";
import { useTranslationContext } from "context/TranslationContext";
import { getTranslationKey } from "helpers/getTranslationKey";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetEmployeePostProps {
  enabled?: boolean;
}

export const useGetEmployeePost = ({ enabled }: UseGetEmployeePostProps) => {
  const user = useAuthStore((state) => state.user);
  const { t } = useTranslationContext();
  const [postOptions, setPostOptions] = useState<TInputTag[]>([]);

  const queryGetEmployeePostKey = useMemo(() => {
    return queryGetEmployeePost._key(user.language);
  }, [user.language]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetEmployeePostKey,
    enabled: !!user?.idUnique && enabled,
    queryFn: () => queryGetEmployeePost(user.language),
    onSuccess: (res) => {
      const postList: TInputTag[] = res.data.posts.map((post) => ({
        id: post.id,
        name: t(getTranslationKey(post.name)),
      }));
      postList.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      setPostOptions(postList);
    },
  });

  return {
    isLoadingEmployeeEmployeePost: isLoading,
    postOptions,
  };
};
